<template>
  <el-container direction="vertical">
    <el-row>
      <el-col :span="4">
        <el-select
          class="remote-select"
          v-model="params.device_type_id"
          clearable
          placeholder="选择设备类型查询"
          @change="onSearch">
          <el-option
            v-for="item in share.device_typeList"
            :key="item.value"
            :label="item.text"
            :value="item.value">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-select
          class="remote-select"
          v-model="params.server_type"
          clearable
          placeholder="选择系统名称查询"
          @change="onSearch">
          <el-option
            v-for="item in share.serverVersionList"
            :key="item.value"
            :label="item.key"
            :value="item.value">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-select
          class="remote-select"
          v-model="params.invalid_flag"
          clearable
          placeholder="选择状态查询"
          @change="onSearch">
          <el-option
            v-for="item in share.statusList"
            :key="item.value"
            :label="item.text"
            :value="item.value">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="5" class="col_pos_right" align="right">
        <el-button v-permission="'新增版本'" icon="el-icon-plus" @click="addVersion()">新建版本</el-button>
        <el-button class="btn btn_1" @click="onSearch()">刷新</el-button>
      </el-col>
    </el-row>

    <el-container>
      <el-table :data="pageData.items" stripe border :height="$setTableHeight(1, 0)" :header-cell-style="{textAlign: 'center'}" :cell-style="{textAlign: 'center'}">
        <el-table-column v-for="it in tableColList" :key="it.key" :label="it.name" :fixed="it.fixed" :sortable="it.sortable" :sort-method="(a, b) => sortDateTime(a, b, it.key)">
          <template slot-scope="scope">
            <span v-if="it.key === 'invalid_flag'">{{scope.row[it.key] | filterInvalidFlag}}</span>
            <span v-else>{{scope.row[it.key]}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" width="160" label="操作">
          <template slot-scope="scope">
            <el-link type="primary" @click="showPublishContent(scope.row)">发布内容</el-link>
            <!-- icon="iconfont icon-shibaiyuanyin_fabuneirong icon_1" -->
            <el-link type="danger" v-permission="'作废版本'" v-if="!scope.row.invalid_flag" @click="invalidRow(scope.row)">作废</el-link>
            <!-- icon="iconfont icon-shibaiyuanyin_zuofei icon_6" -->
          </template>
        </el-table-column>
      </el-table>
    </el-container>

    <el-pagination
      background
      style="margin-top:14px"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageData.total"
      :current-page="pageData.page"
      @current-change="onPageChange"
      :page-size="params.max_results"
      :page-sizes="$pageSizes"
      @size-change="onPageSizeChange"/>

    <el-dialog width="600px" :title="title" :visible.sync="dialogVisible" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" @closed="componet_select = ''">
      <version-add v-if="componet_select ==='add'" @tableCloseDialog="dialogVisible = false" />
      <el-input v-if="componet_select === 'info'" v-model="comment" type="textarea" :rows="10" readonly />
    </el-dialog>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'
import BasicDataHelper from '@/api/basic_data_helper'
import versionAdd from './add'
import Util from '@/api/util'

export default {
  data () {
    return Backend.initListPage(this, 'version_manage', {
      route_name: '升级列表',
      tableColList: [
        {
          key: 'device_type_name',
          name: '设备类型'
        },
        {
          key: 'server_type_desp',
          name: '系统名称'
        },
        {
          key: 'version',
          name: '版本号'
        },
        {
          key: 'file_size',
          name: '文件大小(B)'
        },
        {
          key: 'creation_time',
          name: '发布时间'
        },
        {
          key: 'invalid_flag',
          name: '状态'
        }
      ],
      params: {
        device_type_id: null,
        server_type: null,
        invalid_flag: null
      },
      share: {
        device_typeList: [],
        serverVersionList: [],
        statusList: [
          {
            text: '已发布',
            value: 0
          },
          {
            text: '已作废',
            value: 1
          }
        ]
      },
      dialogVisible: false,
      title: '',
      componet_select: '',
      comment: ''
    })
  },
  filters: {
    filterInvalidFlag (val) {
      return val ? '已作废' : '已发布'
    }
  },
  components: {
    'version-add': versionAdd
  },
  created () {
    this.share.serverVersionList = BasicDataHelper.getServerVersion(this, 3)
    this.getDeviceTypeList()
  },
  methods: {
    getDeviceTypeList () {
      Backend.filterKeyValueList(this, 'device_type')
    },
    sortDateTime (a, b, key) {
      return Util.sortDateTime(a, b, key)
    },
    onSearch () {
      Backend.queryList(this, this.pageData.filter, 0)
    },
    onPageChange (v) {
      Backend.queryList(this, this.pageData.filter, v)
    },
    onPageSizeChange (v) {
      this.params.max_results = v
      Backend.queryList(this, this.pageData.filter, this.pageData.page === 0 ? 1 : this.pageData.page)
    },
    addVersion () {
      this.dialogVisible = true
      this.title = '版本信息'
      this.componet_select = 'add'
    },
    showPublishContent (row) {
      this.dialogVisible = true
      this.title = '发布内容'
      this.componet_select = 'info'
      this.comment = row.comment
    },
    invalidRow (row) {
      this.$confirm('是否作废？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        Backend.post(this, 'version_manage/package_invalid', { version_id: row.version_id }).then((res) => {
          this.$message.success('作废成功!')
          const index = this.pageData.items.findIndex(it => it.version_id === row.version_id)
          this.pageData.items[index].invalid_flag = true
        })
      }).catch(e => {
      })
    }
  }
}
</script>
